import React from 'react';
import spinner from '../../assets/images/indeks.svg'

class LoadingSpin extends React.Component{
    render(){
        return (
            <div className="ah-loadingspin">
                <img src={spinner} />
            </div>
        );
    }
}

export default LoadingSpin;
